var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cus-card",style:([_vm.customStyle])},[(_vm.showTitle)?_c('div',{staticClass:"cus-card-title"},[_c('div',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._t("title-right")],2):_vm._e(),_vm._v(" "),_vm._t("header"),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5d7e362","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/cuview-ui/components/cus-card/cus-card.vue
// module id = null
// module chunks = 